import apiClient from '../api/base/apiClient'

/**
 * 인증이 풀리기 '직전'에 서버에 알린다.
 *
 * 왜 필요한가
 * ----------
 * '갑자기 로그아웃' 신고가 있었는데 서버에는 아무 흔적이 없었다.
 * 401도, 로그아웃 요청도 0건인데 로그인 화면이 떴다
 * (2026-08-30 doyeon 계정). 토큰을 지우는 일은 전부 이 앱 안에서 벌어지므로,
 * 지우는 쪽에서 알리지 않으면 원인을 좁힐 방법이 없다.
 *
 * 반드시 토큰을 지우기 '전에' 불러야 한다. 지운 뒤에는 이 요청도 401이 되어
 * 아무것도 남지 않는다.
 *
 * 실패는 무시한다. 진단 때문에 로그아웃이 막히면 안 된다.
 */
export function reportAuthLost(reason: string, detail?: string): void {
  // localStorage에 토큰이 없으면 어차피 보낼 자격이 없다.
  if (!localStorage.getItem('auth_token')) {
    return
  }

  try {
    void apiClient
      .post(
        '/diagnostics/auth-lost',
        {
          reason,
          url: window.location.pathname + window.location.search,
          detail: detail?.slice(0, 500),
        },
        { skipErrorHandler: true } as any
      )
      .catch(() => {
        /* 진단 실패는 조용히 넘어간다 */
      })
  } catch {
    /* 진단 실패는 조용히 넘어간다 */
  }
}
